import { useDraggable } from '@dnd-kit/core';
import { NodeType } from '../types';

export type GanttDraggableData = {
  id: number;
  duration?: number;
  possibleQueues?: number[];
  type: NodeType.TASK | NodeType.BATCH;
};

type UseGanttDraggableProps = {
  id: number;
  disabled: boolean;
  data: GanttDraggableData;
};

export const useGanttDraggable = (options: UseGanttDraggableProps) => useDraggable(options);
